import { createFileRoute } from '@tanstack/react-router'
import { AuditorEvidenceRoutePage } from '@/components/auditor-center/AuditorCyclePages'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/evidence',
)({
  component: AuditorEvidenceRoutePage,
})
